// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Gallery_Wrapper__MWbkY","Image":"Gallery_Image___YqaA","ImageIn":"Gallery_ImageIn__KRGSg"};